import * as React from 'react';
import s from './PlanSections.scss';
import { Button } from '@wix/design-system';

interface ShowMoreFeaturesButtonProps {
  suffixIcon: React.ReactElement;
  onClick(): void;
}

export const ShowMoreSectionsButton: React.FC<ShowMoreFeaturesButtonProps> = ({
  suffixIcon,
  onClick,
  children,
}) => (
  <div className={s.showMoreSections}>
    <Button
      suffixIcon={suffixIcon}
      onClick={onClick}
      size='large'
      skin='inverted'
      className={s.showMoreSectionsButton}
      dataHook='show-more-features-button'
    >
      {children}
    </Button>
  </div>
);
